<template>
  <div class="main-nav">
    <b-navbar toggleable="lg" class="nav">
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item to="/uebersicht" v-intro="'<strong>Übersicht - Gesuch erfassen</strong><br><br>Sie befinden sich jetzt auf der Übersichtsseite, wo Sie ein neues Gesuch erfassen oder den Status Ihrer Gesuche ansehen können.'" v-intro-step="2" v-intro-position="'right'">
            <span class="icon icon-bar_chart"></span>Übersicht
          </b-nav-item>
          <b-nav-item to="/person" v-intro="'<strong>Personen</strong><br><br>In der Rubrik Personen können Sie Kontaktpersonen erfassen, die ein Gesuch sehen oder bearbeiten dürfen. Eine neue Person können Sie auch dann erfassen, wenn Sie ein neues Gesuch erstellen. Sie können im neuen Gesuch oder auch unter Personen optional einen technischen Kontakt (z.B. einen Installateur) festlegen, der bei technischen Fragen durch die Energieagentur kontaktiert werden kann.'" v-intro-step="4" v-intro-position="'right'">
            <span class="icon icon-person"></span>Personen
          </b-nav-item>
          <b-nav-item to="/gebaeude" v-intro="'<strong>Gebäude</strong><br><br>In der Rubrik Gebäude können Sie ein Gebäude mit Adresse erfassen, für die Sie Gesuche stellen möchten. So können Sie später im Gesuch das Gebäude nur noch auswählen. Falls Sie mehrere Gebäude verwalten und erfassen, vereinfacht das die Erfassung von mehreren Gesuchen. Mit der Anbindung an Swisstopo wird die Parzellennummer automatisch eingefügt.'" v-intro-step="6" v-intro-position="'right'">
            <span class="icon icon-date_range"></span>Gebäude
          </b-nav-item>
          <b-nav-item to="/foerdergeld-rechner" v-intro="'<strong>Fördergeldrechner</strong><br><br>Der Fördergeldrechner zeigt Ihnen an, wie viel Fördergeld Sie pro Massnahme erhalten könnten. Weiter finden Sie zu jeder Massnahme eine Wegleitung als PDF mit Anforderungen. Wählen Sie dazu die Massnahme und die Gemeinde im Fördergeldrechner aus.'" v-intro-step="7" v-intro-position="'right'">
            <span class="icon icon-calculator"></span>Fördergeldrechner
          </b-nav-item>
          <b-nav-item to="/hilfe" v-intro="'<strong>Hilfe</strong><br><br>Hier finden Sie Tipps und die Kontaktangaben der Energieagentur. Wenn Sie ein neues Gesuch erstellen, finden Sie einen Link auf die entsprechende Wegleitung. Wählen Sie im ersten Schritt das Gebäude oder die Gemeinde aus, dann erscheint der Link auf die Wegleitung.'" v-intro-step="8" v-intro-position="'right'">
            <span class="icon icon-help"></span>Hilfe
          </b-nav-item>
          <b-nav-item to="/firmenkonto" class="logout-mobile" v-if="isOrganisationAccount">
            <span class="icon icon-office"></span>Firmenkonto
          </b-nav-item>
          <b-nav-item to="/einstellungen" v-intro="'<strong>Einstellungen</strong><br><br>Passen Sie hier Ihre persönlichen Daten an, die im Profil abgespeichert sind. Hier können Sie bei Bedarf die Mobilnummer für den SMS-Empfang ändern, wie auch das Passwort. Klicken Sie danach auf <span>Profil speichern</span>.'" v-intro-step="9" v-intro-position="'right'">
            <span class="icon icon-settings"></span>Einstellungen
          </b-nav-item>
          <b-nav-item @click="onLogout" class="logout-mobile">
            <span class="icon icon-logout"></span>Ausloggen
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    methods: {
      async onLogout () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('user/LOGOUT').finally(() => {
          this.$router.push({ path: '/' }).catch(() => {})
        })
      }
    },
    computed: {
      ...mapState({
        isOrganisationAccount: state => state.user.currentUser.isOrganisationAccount
      })
    }
  }
</script>

<style lang="scss" scoped>
 .main-nav{
    background: $black-10;
    height: 100%;

    @include media-breakpoint-down(md) {
      background: none;
    }

    .navbar{
      padding: 0;

      .logout-mobile{
        display: none;

        @include media-breakpoint-down(md) {
          display: block;
        }
      }
    }

    ul{
      width: 100%;
      flex-direction: column;
    }

    .icon{
      font-size: 20px;
      padding-right: 0.5rem;
    }

    .nav-link{
      color: $white;
      font-size: $font-size-lg;
      display: flex;
      padding: 1rem 0.7rem;
      border-bottom: 1px solid $black-60;
      border-left: 10px solid transparent;
      text-decoration: none;
      background: $black-80;
      line-height: 1.6;

      &:hover{
        text-decoration: none;
        color: $white;
      }
      &.router-link-active{
        background: $black-60;
        border-left: 10px solid $green-50;
        color: $white;
      }
    }
  }
</style>
